import { composeIO } from 'react-compose-io'
import { collapseInadimplenciaTableIO } from './CollapseInadimplenciaTable.IO'
import { CollapseInadimplenciaTableView } from './CollapseInadimplenciaTable.View'

export const CollapseInadimplenciaTable = composeIO(CollapseInadimplenciaTableView, collapseInadimplenciaTableIO)
